"use strict";

exports.__esModule = true;
exports.Tag = void 0;

var React = _interopRequireWildcard(require("react"));

var _Tag = require("./Tag.styles");

var _hooks = require("@manifest-ui/hooks");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/tag/src/Tag.tsx";

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Tag = React.forwardRef((props, ref) => {
  const {
    children,
    dismissIconProps = {},
    icon: iconProp,
    isActive,
    isDisabled,
    isClickable,
    isDismissible,
    onClick,
    onDismiss,
    onKeyUp,
    onKeyDown,
    size = 'large',
    variant = 'outlined',
    ...other
  } = props;
  const tagRef = React.useRef(null);
  const mergedRef = (0, _hooks.useMergedRef)(tagRef, ref);
  const handleDismiss = React.useCallback(event => {
    event.stopPropagation();
    onDismiss?.(event);
  }, [onDismiss]);
  const handleKeyDown = React.useCallback(event => {
    if (event.currentTarget === event.target && (event.key === 'Backspace' || event.key === 'Delete')) {
      event.preventDefault();
    }

    onKeyDown?.(event);
  }, [onKeyDown]);
  const handleKeyUp = React.useCallback(event => {
    if (event.currentTarget === event.target) {
      if (onDismiss && (event.key === 'Backspace' || event.key === 'Delete')) {
        onDismiss(event);
      } else if (event.key === 'Escape' && tagRef.current) {
        tagRef.current.blur();
      }
    }

    onKeyUp?.(event);
  }, [onDismiss, onKeyUp]);
  let icon = null;

  if (iconProp && React.isValidElement(iconProp)) {
    icon = React.cloneElement(iconProp, {
      className: 'manifestui-tag-icon'
    });
  }

  return React.createElement(_Tag.StyledTag, _extends({
    as: isClickable || onDismiss ? 'button' : 'div',
    className: "manifestui-tag",
    "data-active": isActive ? '' : null,
    "data-clickable": isClickable ? '' : null,
    "data-disabled": isDisabled ? '' : null,
    "data-dismissible": isDismissible ? '' : null,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: mergedRef,
    size: size,
    variant: variant
  }, isClickable && {
    role: 'button',
    tabIndex: isDisabled ? -1 : 0
  }, other, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 5
    }
  }), icon, React.createElement(_Tag.StyledTagText, {
    className: "manifestui-tag-text",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 130,
      columnNumber: 7
    }
  }, children), isDismissible && React.createElement(_Tag.StyledDismissIcon, _extends({
    className: "manifestui-tag-dismiss",
    onClick: handleDismiss
  }, dismissIconProps, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 9
    }
  })));
});
exports.Tag = Tag;
Tag.displayName = 'Tag';